/* tslint:disable */
/* eslint-disable */
/**
 * API SPECS
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { BaseModel } from './BaseModel';
import {
    BaseModelFromJSON,
    BaseModelFromJSONTyped,
    BaseModelToJSON,
} from './BaseModel';
import type { MedicAllOf } from './MedicAllOf';
import {
    MedicAllOfFromJSON,
    MedicAllOfFromJSONTyped,
    MedicAllOfToJSON,
} from './MedicAllOf';

/**
 * 
 * @export
 * @interface Medic
 */
export interface Medic {
    /**
     * 
     * @type {number}
     * @memberof Medic
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof Medic
     */
    createdAt?: string;
    /**
     * 
     * @type {string}
     * @memberof Medic
     */
    updatedAt?: string;
    /**
     * 
     * @type {number}
     * @memberof Medic
     */
    babyId?: number;
    /**
     * 
     * @type {number}
     * @memberof Medic
     */
    userId?: number;
    /**
     * 
     * @type {string}
     * @memberof Medic
     */
    dateCreatePrescription?: string;
    /**
     * 
     * @type {string}
     * @memberof Medic
     */
    prescriptionDrugName?: string;
    /**
     * 
     * @type {string}
     * @memberof Medic
     */
    quantity?: string;
    /**
     * 
     * @type {string}
     * @memberof Medic
     */
    quantityUsed?: string;
    /**
     * 
     * @type {string}
     * @memberof Medic
     */
    pharmacyName?: string;
    /**
     * 
     * @type {string}
     * @memberof Medic
     */
    contents?: string;
    /**
     * 
     * @type {string}
     * @memberof Medic
     */
    sideEffectAndNotes?: string;
}

/**
 * Check if a given object implements the Medic interface.
 */
export function instanceOfMedic(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function MedicFromJSON(json: any): Medic {
    return MedicFromJSONTyped(json, false);
}

export function MedicFromJSONTyped(json: any, ignoreDiscriminator: boolean): Medic {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'createdAt': !exists(json, 'createdAt') ? undefined : json['createdAt'],
        'updatedAt': !exists(json, 'updatedAt') ? undefined : json['updatedAt'],
        'babyId': !exists(json, 'babyId') ? undefined : json['babyId'],
        'userId': !exists(json, 'userId') ? undefined : json['userId'],
        'dateCreatePrescription': !exists(json, 'dateCreatePrescription') ? undefined : json['dateCreatePrescription'],
        'prescriptionDrugName': !exists(json, 'prescriptionDrugName') ? undefined : json['prescriptionDrugName'],
        'quantity': !exists(json, 'quantity') ? undefined : json['quantity'],
        'quantityUsed': !exists(json, 'quantityUsed') ? undefined : json['quantityUsed'],
        'pharmacyName': !exists(json, 'pharmacyName') ? undefined : json['pharmacyName'],
        'contents': !exists(json, 'contents') ? undefined : json['contents'],
        'sideEffectAndNotes': !exists(json, 'sideEffectAndNotes') ? undefined : json['sideEffectAndNotes'],
    };
}

export function MedicToJSON(value?: Medic | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'createdAt': value.createdAt,
        'updatedAt': value.updatedAt,
        'babyId': value.babyId,
        'userId': value.userId,
        'dateCreatePrescription': value.dateCreatePrescription,
        'prescriptionDrugName': value.prescriptionDrugName,
        'quantity': value.quantity,
        'quantityUsed': value.quantityUsed,
        'pharmacyName': value.pharmacyName,
        'contents': value.contents,
        'sideEffectAndNotes': value.sideEffectAndNotes,
    };
}

